import React from 'react';
import { AlertTriangleIcon, ClockIcon } from 'lucide-react';
import { Countdown } from './Countdown';
import { PricingCards } from './PricingCards';
import { SectionHeading } from './SectionHeading';
import { premiumRows } from '../data/salesData';
export function OfferSection() {
  return <section id="oferta" className="border-b border-[var(--line)] bg-[var(--bg)] py-16 sm:py-20" data-id="element-142" data-mp="ddvhxkufwph7">
      <div className="mx-auto max-w-6xl px-4" data-id="element-143" data-mp="idzw347vl849">
        {/* Precio especial */}
        <div className="mx-auto max-w-2xl rounded-2xl border border-[var(--rose)]/30 bg-[var(--surface)] p-6 text-center sm:p-8" data-id="element-144" data-mp="mejueb46qhrz">
          <p className="mb-5 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.25em] text-[var(--rose)]" data-id="element-145" data-mp="rey0hnm87hnd">
            <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-146" data-mp="wawx1yhpk5yv" />
            Precio especial: vence en 48 horas
          </p>
          <Countdown data-id="element-147" data-mp="2y4cqt493e0y2" />
          <p className="mt-6 flex items-center justify-center gap-2 text-sm text-[var(--rose)]" data-id="element-148" data-mp="2y3kshlo41p43">
            <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-149" data-mp="12ns378wk6iz6" />
            Después sube $8.000 ARS. No vuelve.
          </p>
        </div>

        <SectionHeading className="mt-16" data-id="element-150" data-mp="xvh0jyafoj2x">Elegí tu plan</SectionHeading>

        <div className="mt-10" data-id="element-151" data-mp="syiabqtw4wa0">
          <PricingCards data-id="element-152" data-mp="svmf4a9fglp9" />
        </div>

        {/* Comparación Premium */}
        <div className="mx-auto mt-16 max-w-3xl" data-id="element-153" data-mp="oxomsykd1jhn">
          <h3 className="text-center font-serif-display text-[28px] font-bold text-[var(--text)] sm:text-3xl" data-id="element-154" data-mp="1lm4ccungzsur">
            ¿Qué agrega Premium?
          </h3>

          <div className="sales-scrollbar mt-6 overflow-x-auto pb-3" data-id="element-155" data-mp="1go2sw8m4trir">
            <table className="w-full min-w-[640px] border-separate border-spacing-0 overflow-hidden rounded-2xl border border-[var(--line)] text-left text-sm" data-id="element-156" data-mp="1ckmxfflstx7n">
              <thead data-id="element-157" data-mp="169gkupgqi14">
                <tr className="bg-[var(--surface-2)]" data-id="element-158" data-mp="16sy4ab7b4em">
                  <th className="p-4 font-semibold text-[var(--text)]" data-id="element-159" data-mp="146gtiyidaj7">
                    Situación
                  </th>
                  <th className="p-4 font-semibold text-[var(--danger)]" data-id="element-160" data-mp="3tu99j850tdia">
                    ❌ Sin Premium
                  </th>
                  <th className="p-4 font-semibold text-[var(--rose)]" data-id="element-161" data-mp="2mn69gm7rd1y">
                    ✅ Con Premium
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-162" data-mp="3oudfa0m4l0fx">
                {premiumRows.map((row, i) => <tr key={row.situation} className={i % 2 === 0 ? 'bg-[var(--surface)]' : 'bg-[var(--bg-alt)]'} data-id="element-163" data-mp="3owr802tc20kb" data-mpi={i}>
                    <td className="w-[30%] border-t border-[var(--line)] p-4 font-semibold text-[var(--text)]" data-id="element-164" data-mp="3fvt55numrz3b">
                      {row.situation}
                    </td>
                    <td className="w-[30%] border-t border-[var(--line)] p-4 text-[var(--text-soft)]" data-id="element-165" data-mp="365ginq399vuj">
                      {row.without}
                    </td>
                    <td className="border-t border-[var(--line)] p-4 text-[var(--text)]/90" data-id="element-166" data-mp="2x3qq2gxn0qv6">
                      {row.with}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>;
}